/**
 * OverLay Stateless Component
 */
import * as React from "react";
import { Translate } from "react-localize-redux";

const OverLay: React.StatelessComponent = (): React.ReactElement<object> => (
  <div>
    <div className="box-overlay" />
    <div className={"box-overlay-text"}>
      <div className="box-overlay-message">
        <Translate id="overlayMessageTitle" />
      </div>
      <div className="box-overlay-message-subtitle">
        <Translate id="overlayMessageSubtitle" />
      </div>
      <div className="box-overlay-spinner">
        <div className="spinner-cont">
          <span className="spin-move" />
        </div>
      </div>
    </div>
  </div>
);

export { OverLay };



// WEBPACK FOOTER //
// ./src/components/OverLay/OverLayComponent.tsx